var impressum = "Įspūdis";
var privacy = "Privatumo ir teisinė informacija";
var recallInfo = "Atšaukimai";
var signOut = "Atsijungti";
var lt_lt = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { lt_lt as default, impressum, privacy, recallInfo, signOut };
